/*
 * Encapsulates environment specific config, populated from the associated
 * .env file at compile time.
 *
 */
const ENV = {
  /* APIs */
  API_PLATFORM_URL: import.meta.env.VITE_API_PLATFORM_URL,

  /* Auth */
  AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  AUTH0_CALLBACK_URL: import.meta.env.VITE_AUTH0_CALLBACK_URL,
  AUTH0_LOGOUT_URL: import.meta.env.VITE_AUTH0_LOGOUT_URL,

  /* Cognito Auth */
  VITE_AUTH_URL: import.meta.env.VITE_AUTH_URL,

  /* UI Urls */
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  STUDIO_2_URL: import.meta.env.VITE_STUDIO_2_URL,

  /* Intercom */
  INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,

  /* Segment */
  SEGMENT_WRITE_KEY: import.meta.env.VITE_SEGMENT_WRITE_KEY,

  /* PostHog */
  POSTHOG_TOKEN: import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN,
  POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,

  /* Sentry */
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};

export default ENV;
